import { Injectable } from '@angular/core';
import { AuthenticationService } from './authentication.service';
import { OnInit } from '@angular/core';
import { getGlobalUserInfo } from "src/app/others/auth/auth-storage";

@Injectable({
  providedIn: 'root'
})



export class UserroutesService implements OnInit {

  ngOnInit() {

  }

  constructor(public auth: AuthenticationService) { }

  getPermission() {
    const userId = getGlobalUserInfo()?.id || sessionStorage.getItem("userID") || localStorage.getItem("userID") || this.auth.userID();
    return this.auth.get("user_permissions/" + userId).pipe((a) => a);
  }
}
